const formatMasterObjects = data =>
  data.map(item => ({
    label: item.name,
    value: item.id || item.timeSeriesId
  }));

export const initialState = {
  dashboardTypesLookupValues: {}
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET DASHBOARD LOOKUP TYPES':
      return {
        dashboardTypesLookupValues: {
          ...state.dashboardTypesLookupValues,
          [action.payload.id]: formatMasterObjects(action.payload.data)
        }
      };

    default:
      return state;
  }
};
